// extracted by mini-css-extract-plugin
export var container = "_aj-0";
export var containerTopRight = "_aj-1";